export const OAuthSettings = {
    appId: 'a01f76c9-e85b-4d66-87b0-6273f6073ac0',
    scopes: [
      'user.read'
    ]
  };
